import { useMemo } from "react";
import type { BreedProps } from "@/components/pages/Breed/breed.types";

export const useBreedData = (
  breed: BreedProps["breed"],
  params: BreedProps["params"]
) => {
  const breedData = useMemo(() => {
    const {
      name,
      description,
      gallery,
      altura,
      peso,
      expectativaDeVida,
      tamanho,
      cores,
      pelagem,
      caracteristicasComportamentais,
      gruposFCI,
      classificacaoFIFE,
      accordions,
      caracteristicasFisicas,
      imagemCaracteristicasFisicas,
      filhoteImage,
      filhoteDescription,
      faq
    } = breed;

    const tecnicalSpecifications = {
      altura,
      peso,
      expectativaDeVida,
      tamanho,
      cores,
      pelagem,
      caracteristicasComportamentais,
      gruposFCI,
      classificacaoFIFE
    };

    const initialAccordions = accordions.slice(0, 3);
    const restAccordions = accordions.slice(3);
    const hasGallery = gallery?.length > 0;

    const breadcrumb = [
      {
        label: "Raças"
      },
      {
        label: `Raças de ${(params?.especie ?? "").charAt(0).toUpperCase() + (params?.especie ?? "").slice(1)}`,
        href: `/racas/${params?.especie}`
      },
      {
        label: name
      }
    ];

    return {
      name,
      description,
      gallery,
      tecnicalSpecifications,
      initialAccordions,
      restAccordions,
      caracteristicasFisicas,
      imagemCaracteristicasFisicas,
      filhoteImage,
      filhoteDescription,
      faq,
      hasGallery,
      breadcrumb
    };
  }, [breed, params]);

  return breedData;
};
